import api from "@/services/Api";

const mapped = (v) => {
  return v.map(({ id, name, uf }) => ({
    text: `${name} (${uf})`,
    value: id,
  }));
};

export default {
  async insertState({ dispatch }, state) {
    let resp = api.post("states", state);
    if (resp.status) dispatch("listStates");
    return resp.data;
  },

  async listStates({ commit }) {
    let { data } = await api.get("states");
    return mapped(data);
  },

  async listStatesWithFarm({ commit }) {
    let { data } = await api.get("states/with-farm");
    return mapped(data);
  },
};
